import {
  getUtmParams,
  sanitizeProperties,
  analyticsMapping,
  getPlatform
} from "./utils";
import Cookies from "js-cookie";
import Router from "next/router";
import { trackAPI, viewAPI } from "@service/segmentService";
import { store } from "@store/store";
import { getRequestpayload } from "@utils/index";
import omit from "lodash/omit";

export const analyticEvents = async (eventsData: any) => {
  const { event_name, isViewEvent = false, ...rawRest } = eventsData || {};
  const restPayload = omit(rawRest, ["okind", "journeyVersion"]);
  const eventName = event_name;

  const { proposal_ekey, current_node } = Router.query;
  const state = store?.getState();

  const { view_name } = restPayload.customData || {};

  // always include payload data in sending segment event
  // rather than custom including at each level
  // const payloadData = state?.globalState?.payloadData || {};

  const analyticsData: any = state?.analytics || {};
  const instrumentationData: any = state?.globalState?.instrumentationData || {};
  const isAndroidApp = Cookies.get("webview") === "android_app";
  const androidData = isAndroidApp
    ? {
      android: true,
      android_app_version: Cookies.get("android_app_version")
    }
    : {};

  const utmParams = getUtmParams();

  // const filteredData = {
  //   ...Object.entries(analyticsMapping).reduce((a, [k, v]) => {
  //     // eslint-disable-next-line no-prototype-builtins
  //     if (analyticsData?.hasOwnProperty(k)) {
  //       return {
  //         ...a,
  //         [v]: analyticsData[k],
  //       };
  //     }
  //     return a;
  //   }, {}),
  // };

  const filteredData = {
    ...Object.entries(analyticsData).reduce((a, [k, v]) => {
      const mappedKey = analyticsMapping[k];

      if (k === "current_node") {
        return {
          ...a,
          ["page_name"]: v,
          ["current_node"]: v
        };
      }

      return {
        ...a,
        [mappedKey || k]: v
      };
    }, {})
  };
  const { journey } = getRequestpayload();

  const commonAttributes = {
    journey,
    platform: getPlatform(!window.isDesktop),
    product: "auto",
    landing_page: window.location.href,
    path: window.location.href,
    url: window.location.href,
    referrer: document.referrer,
    page_referrer: document.referrer,
    current_node: current_node,
    ...androidData,
    ...filteredData,
    ...restPayload.edata,
    ...restPayload.odata,
    ...restPayload.customData,
    ...instrumentationData,
    proposal_id: proposal_ekey,
    ...(view_name === "view_page_plan_page" ? { publish: true } : {}),
    ...utmParams
  };

  const payload = {
    event_name: eventName,
    customAttributes: {
      ...commonAttributes,
      user_ekey: (Cookies.get("trackerid") || "").split(":")[0],
      tracker_id: (Cookies.get("trackerid") || "")
      // ...payloadData,
    }
  };

  const segmentAPI =
    isViewEvent || eventName?.toUpperCase()?.includes("VIEW")
      ? viewAPI
      : trackAPI;

  const shouldClearViewAttrs =
    !isViewEvent && !eventName?.toUpperCase()?.includes("VIEW");

  payload.customAttributes = {
    ...payload.customAttributes,
    ...(shouldClearViewAttrs ? { view_name: "", view_type: "" } : {})
  };

  segmentAPI({
    ...payload,
    customAttributes: sanitizeProperties(payload.customAttributes)
  });
};
